var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.705 475.295h112.032v-342.29h-102.032c-5.507 0-10 4.493-10 10zm300.558 0h112.032v-332.29c0-5.508-4.493-10-10-10h-102.032z",
    fill: "#8d9ca8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250 19c0-3.314 2.686-6 6-6s6 2.686 6 6v99.454c0 3.314-2.686 6-6 6s-6-2.686-6-6z",
    fill: "#7a8c98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.259 49.681h107.481c5.508 0 10 4.492 10 10v60.335h-127.48v-60.335c0-5.507 4.492-10 9.999-10z",
    fill: "#8d9ca8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.737 83.386h188.527c5.508 0 10 4.492 10 10v388.761h-208.527v-388.761c0-5.508 4.492-10 10-10z",
    fill: "#9facba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.437 270.581h129.127c2.754 0 5 2.246 5 5v23.705c0 2.754-2.246 5-5 5h-129.127c-2.754 0-5-2.246-5-5v-23.706c0-2.754 2.246-4.999 5-4.999zm-103.066-102.875h24.701c2.754 0 5 2.246 5 5v24.701c0 2.754-2.246 5-5 5h-24.701c-2.754 0-5-2.246-5-5v-24.701c0-2.755 2.246-5 5-5zm0 152.126h24.701c2.754 0 5 2.246 5 5v24.701c0 2.754-2.246 5-5 5h-24.701c-2.754 0-5-2.246-5-5v-24.701c0-2.754 2.246-5 5-5zm0-76.063h24.701c2.754 0 5 2.246 5 5v24.701c0 2.754-2.246 5-5 5h-24.701c-2.754 0-5-2.246-5-5v-24.701c0-2.754 2.246-5 5-5zm0 152.126h24.701c2.754 0 5 2.246 5 5v24.701c0 2.754-2.246 5-5 5h-24.701c-2.754 0-5-2.246-5-5v-24.701c0-2.754 2.246-5 5-5zm310.558-228.189h24.701c2.754 0 5 2.246 5 5v24.701c0 2.754-2.246 5-5 5h-24.701c-2.754 0-5-2.246-5-5v-24.701c0-2.755 2.246-5 5-5zm0 152.126h24.701c2.754 0 5 2.246 5 5v24.701c0 2.754-2.246 5-5 5h-24.701c-2.754 0-5-2.246-5-5v-24.701c0-2.754 2.246-5 5-5zm0-76.063h24.701c2.754 0 5 2.246 5 5v24.701c0 2.754-2.246 5-5 5h-24.701c-2.754 0-5-2.246-5-5v-24.701c0-2.754 2.246-5 5-5zm0 152.126h24.701c2.754 0 5 2.246 5 5v24.701c0 2.754-2.246 5-5 5h-24.701c-2.754 0-5-2.246-5-5v-24.701c0-2.754 2.246-5 5-5zm-207.492-277.441h129.127c2.754 0 5 2.246 5 5v23.705c0 2.754-2.246 5-5 5h-129.127c-2.754 0-5-2.246-5-5v-23.705c0-2.754 2.246-5 5-5zm0 76.063h129.127c2.754 0 5 2.246 5 5v23.705c0 2.754-2.246 5-5 5h-129.127c-2.754 0-5-2.246-5-5v-23.705c0-2.754 2.246-5 5-5z",
    fill: "#a6e7f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.437 354.532h129.127c2.754 0 5 2.246 5 5v115.763h-139.127v-115.763c0-2.754 2.246-5 5-5z",
    fill: "#a6e7f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250 354.532h12v120.763h-12z",
    fill: "#6bd9e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 465.295h460c5.508 0 10 4.492 10 10v13.705c0 5.508-4.492 10-10 10h-460c-5.508 0-10-4.492-10-10v-13.705c0-5.508 4.492-10 10-10z",
    fill: "#7a8c98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporation);
export default __webpack_public_path__ + "static/media/corporation.2dd4934bc8f7670fbc3019dcc0dc27ab.svg";
export { ForwardRef as ReactComponent };